import React from 'react';

export default function NavigationTabs({ theme, activeTab, setActiveTab }) {
  return (
    <nav className={`${theme.bg} border-b ${theme.border} px-4 py-3 transition-colors duration-500`}>
      <div className="flex gap-2 max-w-md mx-auto p-1.5 bg-[#151515] border border-white/10 rounded-full shadow-inner">
        <button 
          onClick={() => setActiveTab('entreno')} 
          className={`flex-1 py-3 font-black text-xs uppercase tracking-widest transition-all rounded-full ${
            activeTab === 'entreno' 
              ? 'bg-white text-black shadow-lg scale-[1.02]' 
              : 'text-gray-400 hover:text-white'
          }`}
        >
          Entreno
        </button>
        <button 
          onClick={() => setActiveTab('nutricion')} 
          className={`flex-1 py-3 font-black text-xs uppercase tracking-widest transition-all rounded-full ${
            activeTab === 'nutricion' 
              ? 'bg-white text-black shadow-lg scale-[1.02]' 
              : 'text-gray-400 hover:text-white'
          }`}
        >
          Nutrición
        </button>
        <button 
          onClick={() => setActiveTab('seguimiento')} 
          className={`flex-1 py-3 font-black text-xs uppercase tracking-widest transition-all rounded-full ${
            activeTab === 'seguimiento' 
              ? 'bg-white text-black shadow-lg scale-[1.02]' 
              : 'text-gray-400 hover:text-white'
          }`}
        >
          Progreso
        </button>
      </div>
    </nav>
  );
}